import { render } from "./ClientDropdownMultiple.vue?vue&type=template&id=18e9bcb0"
import script from "./ClientDropdownMultiple.vue?vue&type=script&lang=js"
export * from "./ClientDropdownMultiple.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__